module.exports = __webpack_public_path__ + "static/media/palms1.deeb2ef2.png";